/* global __WEB__ */

/**
 * Redux middleware that ensures the application scrolls to the top of the
 * page on each location change. This is to ensure that the user is show
 * the navigation menu on each location change.
 * Additionally it solves an issue in the native iOS app where the window
 * is scrolled to an offset of about 40px on location changes, which doesn't
 * look very nice.
 */
export default function navigationScrollMiddleware() {
    return (/* store */) => (next) => (action) => {
        if (action.type === '@@router/LOCATION_CHANGE'
            || action.type === '@@app/SET_TITLE') {
            if (window) {
                // eslint-disable-next-line
                let domElement = document.getElementById('application');

                if (domElement) {
                    domElement.scrollLeft = 0;
                    domElement.scrollTop = 0;
                }

                window.scrollTo(0, 0);
            }
        }

        return next(action);
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/middlewares/navigationScrollMiddleware.js
 **/